// Thin wrapper around GA4's gtag (loaded in index.html). Safe everywhere:
// no-ops during prerender and when the tag is blocked by an ad blocker.
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch {
    // analytics must never break the app
  }
};
